namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_vk_group_search, {

		// align: {
		// 	items: 'flex-end',
		// },
		
		Search_label: {
			Content: {
				gap: $mol_gap.block,
			},
			flex: {
				grow: 1,
			},
		},

		Group: {
			padding: $mol_gap.text,
			gap: $mol_gap.block,
		},

		Name_block: {
			flex: {
				direction: 'column',
			},
		},

		Members_count: {
			gap: $mol_gap.block,
		},

		Members_count_icon: {
			width: '1.25rem',
		},
		
	} )
	
}
